import { get } from 'lodash';

const root = state => get(state, 'CommonState.report');

export const getReportData = state => get(root(state), 'report');

export const getReportFetching = state => get(root(state), 'fetching');

export const getReportError = state => get(root(state), 'error');



// WEBPACK FOOTER //
// ./src/state/report/selectors.js